import * as THREE from 'three';
import { CONFIG } from '../config.js';

/**
 * Manages the Three.js WebGLRenderer with shadow support.
 */
export class Renderer {
    /** @type {THREE.WebGLRenderer} */
    #renderer;

    constructor() {
        this.#renderer = new THREE.WebGLRenderer({ antialias: true });
        this.#renderer.setSize(window.innerWidth, window.innerHeight);
        this.#renderer.shadowMap.enabled = true;
        this.#renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        this.#renderer.outputColorSpace = THREE.SRGBColorSpace;

        document.body.appendChild(this.#renderer.domElement);

        // Handle window resize
        window.addEventListener('resize', () => {
            this.#renderer.setSize(window.innerWidth, window.innerHeight);
        });
    }

    /**
     * Get the renderer canvas
     * @returns {HTMLCanvasElement}
     */
    get domElement() {
        return this.#renderer.domElement;
    }

    /**
     * Render the scene
     * @param {THREE.Scene} scene
     * @param {THREE.Camera} camera
     */
    render(scene, camera) {
        this.#renderer.render(scene, camera);
    }

    /**
     * Dispose of renderer
     */
    dispose() {
        this.#renderer.dispose();
        document.body.removeChild(this.#renderer.domElement);
    }
}
